<ion-content>
  <ion-header>
    <ion-toolbar>
      <ion-title>RVA Mini Map</ion-title>
      <ion-buttons slot="end">
        <ion-button color="medium" (click)="closeModal()">Close<ion-icon name="close"></ion-icon></ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>
  <div id="zoomable-map" style="position: relative; width: 100%; height: 400px; overflow: hidden; touch-action: none;">
    <img src="assets/maps/rvaMiniMap.png" style="width: 100%; height: 100%; object-fit: fill; position: absolute; top: 0; left: 0;" />
    <canvas #miniMapCanvas style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; pointer-events: auto; touch-action: none;"></canvas>
  </div>
</ion-content>
